<template>
  <!--TODO stations table need refactoring with a JS code and JSON file for save data 
  also need indent refactoring-->
  <div class="row">
    <div class="col-md-9 offset-2 breadcrumb-class mt-3">
      Está en: <span><a href="">Resumen</a></span>
    </div>
  </div>
  <div class="col-md-9 offset-md-2">
    <h5 class="text-center">
      RESULTADOS DE LOS INVENTARIOS DE FUENTES FIJAS Y DE FUENTES MÓVILES PARA
      LA CIUDAD DE MANIZALES AÑO 2014
    </h5>

    <div class="mb-4 mt-4">
      <table class="display table" id="first-emision-table">
        <thead>
          <tr>
            <th colspan="11" class="text-center">Emisión (ton/año)</th>
          </tr>

          <tr>
            <td>Tipo de industria</td>
            <td>CO</td>
            <td>NO<sub>X</sub></td>
            <td>SO<sub>X</sub></td>
            <td>PM<sub>10</sub></td>
            <td>TSP</td>
            <td>VOC</td>
            <td>Metales</td>
            <td>CO<sub>2</sub></td>
            <td>CH<sub>4</sub></td>
            <td>N<sub>2</sub>0</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Bebidas y alimentos</td>
            <td>46</td>
            <td>39,9</td>
            <td>62,9</td>
            <td>23,5</td>
            <td>45,5</td>
            <td>0,71</td>
            <td>0,1</td>
            <td>26740</td>
            <td>0,6</td>
            <td>0,4</td>
          </tr>
          <tr>
            <td>Fundición</td>
            <td>160,1</td>
            <td>14,9</td>
            <td>9,5</td>
            <td>8,6</td>
            <td>39,2</td>
            <td>2,08</td>
            <td>0,11</td>
            <td>18609</td>
            <td>0,5</td>
            <td>0,5</td>
          </tr>
          <tr>
            <td>Incineración de residuos</td>
            <td>0,2</td>
            <td>4,7</td>
            <td>0,4</td>
            <td>0,2</td>
            <td>0,3</td>
            <td>0,02</td>
            <td>0,01</td>
            <td>468</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Industria química</td>
            <td>0,4</td>
            <td>3</td>
            <td>16</td>
            <td>0,1</td>
            <td>0,1</td>
            <td>0,02</td>
            <td>0</td>
            <td>1369</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Madera</td>
            <td>0,7</td>
            <td>2,9</td>
            <td>12,7</td>
            <td>0,8</td>
            <td>3,4</td>
            <td>0,04</td>
            <td>0,01</td>
            <td>1912</td>
            <td>0,1</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Metalúrgica</td>
            <td>1,8</td>
            <td>8,7</td>
            <td>0,1</td>
            <td>0,2</td>
            <td>4,2</td>
            <td>0,12</td>
            <td>0</td>
            <td>2687</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Minerales</td>
            <td>7,4</td>
            <td>6,5</td>
            <td>11,6</td>
            <td>3,4</td>
            <td>26,5</td>
            <td>1,26</td>
            <td>0,02</td>
            <td>4101</td>
            <td>0,6</td>
            <td>0,1</td>
          </tr>
          <tr>
            <td>Otros</td>
            <td>0</td>
            <td>1,7</td>
            <td>0</td>
            <td>0,1</td>
            <td>0,2</td>
            <td>0</td>
            <td>0</td>
            <td>64</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Tejas</td>
            <td>2,5</td>
            <td>7,2</td>
            <td>0,3</td>
            <td>0,4</td>
            <td>0,7</td>
            <td>0,12</td>
            <td>0</td>
            <td>8127</td>
            <td>0</td>
            <td>0,1</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-4 mt-4">
      <table class="display table" id="second-emision-table">
        <thead>
          <tr>
            <th colspan="10" class="text-center">Emisión de contaminante (ton/año)</th>
          </tr>
          <tr>
            <th>Categoría</th>
            <th>Parque Automotor año 2014</th>
            <td>CO</td>
            <td>VOC</td>
            <td>NO<sub>X</sub></td>
            <td>SO<sub>X</sub></td>
            <td>PM<sub>10</sub></td>
            <td>CO<sub>2</sub></td>
            <td>N<sub>2</sub>O</td>
            <td>CH<sub>4</sub></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Vehículo<br />
              de pasajeros (PC)
            </td>
            <td>64090</td>
            <td>15902</td>
            <td>1340</td>
            <td>1023</td>
            <td>18</td>
            <td>21</td>
            <td>191902</td>
            <td>6.6</td>
            <td>881</td>
          </tr>
          <tr>
            <td>Motos (2w)</td>
            <td>60625</td>
            <td>21542</td>
            <td>7841</td>
            <td>141</td>
            <td>5.1</td>
            <td>184</td>
            <td>44208</td>
            <td>0.1</td>
            <td>1444</td>
          </tr>
          <tr>
            <td>Taxi</td>
            <td>2402</td>
            <td>4470</td>
            <td>144</td>
            <td>249</td>
            <td>1.2</td>
            <td>6</td>
            <td>48617</td>
            <td>2.6</td>
            <td>535</td>
          </tr>
          <tr>
            <td>Bus</td>
            <td>2367</td>
            <td>755</td>
            <td>177</td>
            <td>2371</td>
            <td>1.2</td>
            <td>362</td>
            <td>118930</td>
            <td>0.9</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Pesados (Truck)</td>
            <td>2528</td>
            <td>727</td>
            <td>144</td>
            <td>1107</td>
            <td>0.5</td>
            <td>192</td>
            <td>50783</td>
            <td>0.4</td>
            <td>0</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push("/Login");
    }
    this.$store.dispatch("sidebar_state", "start");
  },
};
</script>

<style scoped>
</style>
